<!--
  @Description cgc 拼团mvp - 拼团进程
-->
<template>
<div>
  <div v-if="isInProgress" class="group_mvp_process_container">
    <!-- 标题、进度 -->
    <div class="left_wrap">
      <!-- 标题 -->
      <div class="left_title">{{title}}</div>
      <!-- 进度 -->
      <HeadImage
      :recommendCode="recommendCode"
      :copyContent="copyContent"
      :shareConfig="shareConfig"
      @trackCopyClick="trackCopyClick"
      @trackShareClick="$emit('trackShareClick')"
      :images="images"
      :current="data.currentProgress"
      :total="data.totalLadderNum"
      :country="country"
      />
    </div>
    <!-- 倒计时、奖品图 -->
    <div class="right_wrap">
      <!-- 倒计时 -->
      <div class="right_clock">
        <CountDown
        v-if="showClockTimer"
        :expireTime="expireTime"  
        />
      </div>
      <div class="right_prize">
        <Prize
        :backgroundImg="referrerPrizeImg"
        :prizeDesc="prizeDesc"
        />
      </div>
    </div>
  </div>
  <div v-else class="group_mvp_process_completed_container">
    <ProcessCompleted
    :backgroundImg="referrerPrizeImg"
    :prizeDesc="prizeDesc" />
  </div>
</div>
</template>
<script>
import ProcessCompleted from './group_mvp_process_completed'
import HeadImage from './group_mvp_process_headimage'
import CountDown from './group_mvp_process_countdown'
import Prize from './group_mvp_process_prize'
import trackEvent from '@/common/js/track'
export default {
  props: {
    activityID: {
      type: String,
      default: ''
    },
    // 兑换码：FOOD-J82RPF
    recommendCode: {
      type: String,
      default: ''
    },
    // 要复制的内容，比如：Hola, tu amigo te ha enviado MX$130.00 MXN de descuento para tu primer pedido. Obténlo aquí:
    copyContent: {
      type: String,
      default: ''
    },
    shareConfig: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {},
      addIcon: require('../../../../assets/images/cgc/didi/mvp_add_user_new.png')
    },
    country: {
      type: String,
      default: 'MX'
    }
  },
  components: {
    ProcessCompleted,
    HeadImage,
    CountDown,
    Prize
  },
  computed: {
    isInProgress () {
      const { currentProgress, totalLadderNum } = this.data
      return currentProgress < totalLadderNum
    },
    title () {
      const { currentProgress, totalLadderNum } = this.data
      // const amount = rewardInfo && rewardInfo.amountSplit && rewardInfo.amountSplit.display
      const amount = this.prizeDesc
      let translate = this._('FoodC_Notifications_Invite_user_GtIH' /** 再邀请{{user_num}}位新用户完成首单，即可得{{gift}} */)
      translate = translate.replace('{{user_num}}', totalLadderNum - currentProgress)
      translate = translate.replace('{{gift}}', amount)
      return translate
    },
    images () {
      const { referralList, currentProgress, totalLadderNum } = this.data
      const count = totalLadderNum - currentProgress
      const plusArr = Array.from({ length: count }, item => (
        {
          headImg: this.country === 'BR'
            ? require('../../../../assets/images/cgc/99/mvp_add_user.png')
            : require('../../../../assets/images/cgc/didi/mvp_add_user.png'),
          nickName: ''
        }
      ))
      return [...referralList, ...plusArr]
    },
    showClockTimer () {
      const { openCountdown, expireTime } = this.data
      return openCountdown && expireTime
    },
    expireTime () {
      const { expireTime } = this.data
      return expireTime
    },
    referrerPrizeImg () {
      const { referrerPrizeImg } = this.data
      return referrerPrizeImg && referrerPrizeImg.icon
    },
    prizeDesc () {
      const { ladderRule } = this.data
      const ladder = ladderRule[0]
      return ladder && ladder.ladderDesc
    }
  },
  data () {
    return {}
  },
  methods: {
    trackCopyClick () {
      trackEvent({
        eventId: 'sailing_c_x_invitation_copy_ck',
        eventLabel: '点击你的邀请码旁边的复制按钮',
        attrs: {
          from_page: 'CC',
          activity_id: this.activityID || '',
          invite_code: this.recommendCode
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus">
.group_mvp_process_completed_container
  background-color #FFFFFF
  width 702px
  height 224px
  border-radius 12px
.group_mvp_process_container
  background-color #FFFFFF
  position relative
  padding 31px 32px 40px 32px
  width 638px
  height 276px
  border-radius 12px
  .left_wrap 
    height: 276px
    display flex
    flex-direction column
    justify-content space-between
    .left_title
      letter-spacing -0.2px
      height 88px
      width 430px
      font-family Aspira Medium
      font-size 36px
      color #000000
      line-height 44px
      font-weight 500
  .right_wrap
    .right_clock
      position absolute 
      top 34px
      right 32px
    .right_prize
      position absolute 
      right 48px
      bottom 40px
</style>